export default __webpack_public_path__ + "static/media/mobile_language_options_image.6a3e7ca6.png";